import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn-in-nx/ui/select";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";

export function SelectInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const handleValueChange = (newValue) => {
    // Si selecciona el vacío, enviamos null o empty string según tu preferencia, acá pasamos "" o null
    const finalValue = newValue === "_" ? "" : newValue; 
    onChange(finalValue);
    const success = onSave(finalValue); 
    if (success) {
      onCancel();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  const enumValues = schema?.enum || [];
  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  return (
    <div className='w-full h-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Select
                // Interceptar el value actual; si no hay, asignamos "_" para el vacío en shadcn
                value={value === '' || value == null ? "_" : String(value)}
                onValueChange={handleValueChange}
                defaultOpen={autoFocus}
              >
                <SelectTrigger
                  onKeyDown={handleKeyDown}
                  autoFocus={autoFocus}
                  className={errorClass}
                >
                  <SelectValue placeholder="— empty —" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="_">— empty —</SelectItem>
                  {enumValues.map((opt) => {
                    const strOpt = String(opt);
                    return (
                      <SelectItem key={strOpt} value={strOpt}>
                        {strOpt}
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
